/** @format */

import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { allPackage } from "../../../../Features/SetsAPI/SetsSlice";
import { Row, Col } from "react-bootstrap";

const UBTPackages = ({ type }) => {
  const dispatch = useDispatch();

  const allPackageCol = useSelector((state) => state.set.packageCollection);
  const testState = useSelector((state) => state.localset.questionState);
  const currentUserEmail = useSelector(
    (state) => state.auth.currentUser?.email,
  );
  const token = useSelector((state) => state.auth.currentUser?.token);

  useEffect(() => {
    if (!testState.start && token) dispatch(allPackage(token));
  }, [dispatch, testState.start, token]);

  const filteredPackages = useMemo(() => {
    if (!allPackageCol) return [];

    const isAgencyUser =
      currentUserEmail === "learnkoreanbibekuser@yopmail.com";

    return allPackageCol.filter(({ category, status }) => {
      const isActive = [true, 1, "true"].includes(status);
      const isAgency = category?.toLowerCase() === "agency";
      return isActive && (isAgencyUser ? isAgency : !isAgency);
    });
  }, [allPackageCol, currentUserEmail]);

  const handleSaveToLocalStorage = (pkg) => {
    const defaultLogo =
      "https://secureadmin.lkwb.com.np/storage/uploads/1771327905_test.webp";

    const agencyPackage = {
      id: pkg.id,
      logo: pkg.logo || defaultLogo,
      address: pkg.address || "Bijulibazar, Kathmandu",
      phone: pkg.phone || "9813999618",
      email: pkg.email || "learnkoreanbibekuser@yopmail.com",
      website: pkg.website || "https://learnkoreanwithbibek.com",
      category: pkg.category,
      title: pkg.title,
      price: pkg.price,
      discount: pkg.discount,
      sets: pkg.sets,
      base_price: pkg.base_price,
    };

    // if (pkg.category?.toLowerCase() === "agency") {
    //   localStorage.setItem("dashboardLogo", agencyPackage.logo);
    //   setDashboardLogo(agencyPackage.logo);
    // }

    localStorage.setItem("agencyPackage", JSON.stringify(agencyPackage));
    console.log("dashboardLogo", agencyPackage.logo);
    console.log("agency package", agencyPackage);
  };

  return (
    <Row
      className={`packages-container ${type === "columns" ? "columns" : "row"}`}
    >
      {filteredPackages.length > 0 ?
        filteredPackages.map((item) => (
          <Col key={item.id} md={type === "columns" ? 4 : 12}>
            <div className={`buyPackages ${item.category} packagebought`}>
              <div className="d-flex justify-content-between">
                <div>
                  <p>{item.category} Package</p>
                  <h6>{item.title}</h6>
                </div>
                <p className="packageCat">{item.sets?.length || 0} Sets</p>
              </div>

              <div className="pricepkg">
                Rs. <span>{item.price}</span>
                {item.discount !== 0 && <del>{item.base_price}</del>}
              </div>

              <Link
                to={`/dashboard/ubt-package/${item.id}`}
                className="buyBtn"
                onClick={() => handleSaveToLocalStorage(item)}
              >
                View package
              </Link>
            </div>
          </Col>
        ))
      : <Col>
          <p className="text-center mt-3">No packages available.</p>
        </Col>
      }
    </Row>
  );
};

export default UBTPackages;

// import React, { useEffect, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Link } from "react-router-dom";
// import { allPackage } from "../../../../Features/SetsAPI/SetsSlice";
// import { Row, Col } from "react-bootstrap";

// const filterPackagesForUser = (packages) => {
//   if (!packages) return [];

//   return packages.filter((item) => [true, 1, "true"].includes(item.status));
// };

// const UBTPackages = ({ type }) => {
//   const dispatch = useDispatch();

//   const allPackageCol = useSelector((state) => state.set.packageCollection);

//   const testState = useSelector((state) => state.localset.questionState);
//   const token = useSelector((state) => state.auth.currentUser?.token);

//   useEffect(() => {
//     if (!testState.start && token) {
//       dispatch(allPackage(token));
//     }
//   }, [dispatch, testState.start, token]);

//   const filteredPackages = useMemo(() => {
//     return filterPackagesForUser(allPackageCol);
//   }, [allPackageCol]);

//   const handleSaveToLocalStorage = (pkg) => {
//     const agencyPackage = {
//       id: pkg.id,
//       logo:
//         pkg.logo ||
//         "https://secureadmin.lkwb.com.np/storage/uploads/1771327905_test.webp",

//       address: pkg.address || "Bijulibazar, Kathmandu",
//       phone: pkg.phone || "9813999618",
//       email: pkg.email || "",
//       website: pkg.website || "",
//       category: pkg.category,
//       title: pkg.title,
//       price: pkg.price,
//       discount: pkg.discount,
//       sets: pkg.sets,
//       base_price: pkg.base_price,
//     };

//     localStorage.setItem("agencyPackage", JSON.stringify(agencyPackage));
//     localStorage.setItem("dashboardLogo", agencyPackage.logo);
//     console.log("Selected agencyPackage saved to localStorage:", agencyPackage);
//   };

//   return (
//     <Row
//       className={`packages-container ${type === "columns" ? "columns" : "row"}`}
//     >
//       {filteredPackages.length > 0 ?
//         filteredPackages.map((item) => (
//           <Col key={item.id} md={type === "columns" ? 4 : 12}>
//             <div className={`buyPackages ${item.category} packagebought`}>
//               <div className="d-flex justify-content-between">
//                 <div className="text-start">
//                   <p>{item.category} Package</p>
//                   <h6>{item.title}</h6>
//                 </div>
//                 <div className="text-end">
//                   <p className="packageCat">{item.sets?.length || 0} Sets</p>
//                 </div>
//               </div>
//               <div className="pricepkg">
//                 Rs. <span>{item.price}</span>
//                 {item.discount !== 0 && <del>{item.base_price}</del>}
//               </div>
//               <Link
//                 to={`/dashboard/ubt-package/${item.id}`}
//                 className="buyBtn"
//                 onClick={() => handleSaveToLocalStorage(item)}
//               >
//                 View package
//               </Link>
//             </div>
//           </Col>
//         ))
//       : <Col>
//           <p className="text-center mt-3">No packages available.</p>
//         </Col>
//       }
//     </Row>
//   );
// };

// export default UBTPackages;
